import React, { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";

const AdminLogin = () => {
  const { login } = useAuth();
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success(t.admin.login_success);
    } catch (err) {
      const msg =
        err?.response?.data?.detail && typeof err.response.data.detail === "string"
          ? err.response.data.detail
          : t.admin.login_error;
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4 grain">
      <div className="absolute top-0 left-0 right-0 h-1 bg-[var(--hk-red)]" />
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md border border-white/10 bg-[var(--hk-surface)] p-8 md:p-10"
      >
        <div className="text-[10px] tracking-[0.35em] text-[var(--hk-red)] font-bold mb-3">
          HAKAN.TIPS // ADMIN
        </div>
        <h1 className="font-display text-3xl md:text-4xl uppercase tracking-tight mb-2">
          {t.admin.login_title}
        </h1>
        <p className="text-sm text-white/50 mb-8">{t.admin.login_subtitle}</p>

        <label className="block text-[10px] tracking-[0.25em] text-white/50 mb-2">
          {t.admin.email}
        </label>
        <input
          type="text"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid="admin-email"
          className="w-full bg-transparent border border-white/15 px-4 py-3 text-sm mb-5 focus:border-[var(--hk-red)] transition-colors"
        />

        <label className="block text-[10px] tracking-[0.25em] text-white/50 mb-2">
          {t.admin.password}
        </label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          data-testid="admin-password"
          className="w-full bg-transparent border border-white/15 px-4 py-3 text-sm mb-8 focus:border-[var(--hk-red)] transition-colors"
        />

        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="btn-red w-full py-4 text-xs font-bold tracking-[0.3em] disabled:opacity-60"
        >
          {busy ? "..." : `${t.admin.login} →`}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
